import ModalLoadSimsTeacher from "root/s360components/Modals/TeacherLoader/ModalLoadSimsTeacher";
import React, {useRef, useState} from "react";
import Modal from "react-responsive-modal";
import ModalRegistrationResponse from "root/s360components/Modals/Registration/ModalRegistrationResponse";
import {validateMode} from "root/Modals/modalFunctions";

export const ModalLoadSimsTeacherModes = {
    LOAD: 'load',
    CONFIRM: 'confirm',
    NONE: 'none',
}

const useModalLoadSimsTeacher = () =>
{
    const defaultState =  { openState: false, mode: ModalLoadSimsTeacherModes.NONE, enc_school_id: null, teacher: null } ;

    const [dialog, setDialog]  = useState ( defaultState )  ;

    //Success of submission
    const resolvePromise = useRef(null);

    const onClickActivate = ( { mode, enc_school_id, row } ) =>
    {
        validateMode(mode, ModalLoadSimsTeacherModes);

        return new Promise((resolve, reject) => {

            resolvePromise.current = resolve ;

            switch ( mode )
            {
                case ModalLoadSimsTeacherModes.LOAD:
                    setDialog ({ openState: true, mode: mode, enc_school_id: enc_school_id, teacher: row});
                    break ;
            }
        })
    }

    const onCloseModal = () =>
    {
        setDialog (defaultState);

        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( 'cancel' ) ;
        }
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog (defaultState);

        // Tell the parent we're done
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( result ) ;
        }
    };

    const render = ( ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                < ModalLoadSimsTeacher onClose={onCloseModal} enc_school_id={dialog.enc_school_id} teacher={dialog.teacher} mode={dialog.mode} onSaveComplete={onSaveComplete}/>
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalLoadSimsTeacher;